// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"ea0580114652f991643a","453":"2f0d74bf70e545369bed","522":"c6bc7694c5684f63e96d"}[chunkId] + ".js";
};